(function($) {
  'use strict';

  // Configuration object for better maintainability
  const CONFIG = {
    selectors: {
      collectionGrid: '.collection-grid',
      collectionList: '.collection-list',
      sidebar: '.collection-sidebar',
      pagination: '.pagination',
      filterBlock: '.filter-block',
      viewCount: '.view-count',
      collectionInfo: '.collection-info',
      loadingPopup: '.loading',
      errorPopup: '.ajax-error-modal'
    },
    classes: {
      active: 'active',
      productsGrid: 'products-grid'
    }
  };

  const CollectionManager = {
    filterClick: false,
    queryParams: {},

    // Initialize all collection features
    init() {
      this.initCollectionFilter();
      this.initCollectionSorting();
      this.initCollectionShow();
      this.initCollectionViewMode();
      this.initPaging();
      this.initToggle();

      // Setup history state management
      if ($(CONFIG.selectors.sidebar).length) {
        this.setupHistoryManagement();
      }
    },

    // Setup browser history management
    setupHistoryManagement() {
      History.Adapter.bind(window, 'statechange', () => {
        const State = History.getState();
        if (!this.filterClick) {
          this.parseUrlParams();
          const newUrl = this.buildUrl();
          this.fetchAndUpdateContent(newUrl);
          this.resetFilterUI();
        }
        this.filterClick = false;
      });
    },

    // Parse URL parameters into queryParams object
    parseUrlParams() {
      this.queryParams = {};
      if (location.search.length) {
        const params = location.search.substr(1).split('&');
        params.forEach(param => {
          const [key, value] = param.split('=');
          if (key && value) {
            this.queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
          }
        });
      }
    },

    // Build URL from current query parameters
    buildUrl(baseLink) {
      const query = $.param(this.queryParams).replace(/%2B/g, '+');
      if (baseLink) {
        return query ? `${baseLink}?${query}` : baseLink;
      }
      return query ? `${location.pathname}?${query}` : location.pathname;
    },

    // Handle AJAX filter requests
    filterAjaxRequest(baseLink) {
      delete this.queryParams.page;
      const newUrl = this.buildUrl(baseLink);
      this.filterClick = true;
      
      History.pushState({ param: this.queryParams }, newUrl, newUrl);
      this.fetchAndUpdateContent(newUrl);
    },

    // Fetch content via AJAX and update page
    fetchAndUpdateContent(url) {
      $.ajax({
        type: 'GET',
        url: url,
        beforeSend: () => {
          this.showLoading();
        },
        success: (data) => {
          this.updatePageContent(data);
          this.reinitializeComponents();
          this.hideLoading();
        },
        error: (xhr) => {
          this.handleAjaxError(xhr);
        }
      });
    },

    // Update page content with AJAX response
    updatePageContent(data) {
      const $data = $(data);

      // Update product grid/list
      this.updateProductList($data);

      // Update pagination
      this.updateElement(CONFIG.selectors.pagination, $data);

      // Update sidebar filters
      this.updateElement(CONFIG.selectors.filterBlock, $data);

      // Update view count
      this.updateElement(CONFIG.selectors.viewCount, $data);

      // Update collection header
      this.updateCollectionHeader($data);
    },

    // Update product list (grid or list view)
    updateProductList($data) {
      const currentList = $(CONFIG.selectors.collectionGrid).length 
        ? $(CONFIG.selectors.collectionGrid) 
        : $(CONFIG.selectors.collectionList);

      const newList = $data.find(CONFIG.selectors.collectionGrid).length 
        ? $data.find(CONFIG.selectors.collectionGrid) 
        : $data.find(CONFIG.selectors.collectionList);

      if (newList.length) {
        // Apply image cropping if enabled
        if (window.product_image_resize && newList.hasClass(CONFIG.classes.productsGrid)) {
          newList.find('img').fakecrop({
            fill: window.images_size.is_crop,
            widthSelector: `.${CONFIG.classes.productsGrid} .grid-item .product-image`,
            ratioWrapper: window.images_size
          });
        }
        currentList.replaceWith(newList);
      }
    },

    // Update collection header if changed
    updateCollectionHeader($data) {
      const $currentHeader = $(CONFIG.selectors.collectionInfo);
      const $newHeader = $data.find(CONFIG.selectors.collectionInfo);

      if ($currentHeader.find('h3').text() !== $newHeader.find('h3').text()) {
        $currentHeader.find('h3').replaceWith($newHeader.find('h3'));
        
        const $currentDesc = $currentHeader.find('.c-des');
        const $newDesc = $newHeader.find('.c-des');
        
        if ($currentDesc.length && $newDesc.length) {
          $currentDesc.replaceWith($newDesc);
        }
      }
    },

    // Generic element update helper
    updateElement(selector, $data) {
      const $element = $(selector);
      if ($element.length) {
        const $newElement = $data.find(selector);
        if ($newElement.length) {
          $element.replaceWith($newElement);
        }
      }
    },

    // Reinitialize components after content update
    reinitializeComponents() {
      this.setupFilterEvents();
      this.setupClearButtons();
      this.initReview();
      this.initPaging();
      this.initToggle();

      // Reinitialize global functions if available
      if (typeof gred !== 'undefined') {
        gred.ConvertCurrency();
        gred.quickView();
        gred.initWishlist();
        gred.initAddToCart();
      }
    },

    // Initialize product reviews
    initReview() {
      if (window.review && $('.spr-badge').length > 0 && window.SPR) {
        window.SPR.registerCallbacks();
        window.SPR.initRatingHandler();
        window.SPR.initDomEls();
        window.SPR.loadProducts();
        window.SPR.loadBadges();
      }
    },

    // Initialize toggle functionality
    initToggle() {
      // Dropdown caret toggle
      $('.caret').off('click').on('click', function(e) {
        e.preventDefault();
        $(this).parent().next().toggleClass(CONFIG.classes.active);
      });

      // Show active submenu items
      $('.block-category .sub-menu > li').each(function() {
        if ($(this).hasClass(CONFIG.classes.active)) {
          $(this).parent().addClass(CONFIG.classes.active);
        }
      });

      // Dropdown toggle
      $('.dropdown-toggle').off('click').on('click', function(e) {
        e.preventDefault();
        $('.dropdown-content').removeClass(CONFIG.classes.active);
        $(this).next().toggleClass(CONFIG.classes.active);
      });
    },

    // Initialize collection filters
    initCollectionFilter() {
      if ($(CONFIG.selectors.sidebar).length) {
        this.parseUrlParams();
        this.setupFilterEvents();
        this.setupClearButtons();
      }
    },

    // Setup all filter event handlers
    setupFilterEvents() {
      this.setupTagFilters();
      this.setupCategoryFilters();
    },

    // Setup tag filter events
    setupTagFilters() {
      $('.filter-tag a:not(".clear"), .filter-tag label').off('click').on('click', (e) => {
        e.preventDefault();

        const $element = $(e.currentTarget);
        let currentTags = this.queryParams.constraint ? this.queryParams.constraint.split('+') : [];

        // Handle single selection mode
        if (!window.filter_mul_choice && !$element.prev().is(':checked')) {
          const $otherTag = $element.parents('.filter-tag').find('input:checked');
          if ($otherTag.length) {
            const tagName = $otherTag.val();
            currentTags = currentTags.filter(tag => tag !== tagName);
          }
        }

        // Toggle current tag
        const tagName = $element.prev().val();
        if (tagName) {
          const tagIndex = currentTags.indexOf(tagName);
          if (tagIndex >= 0) {
            currentTags.splice(tagIndex, 1);
          } else {
            currentTags.push(tagName);
          }
        }

        // Update query params
        if (currentTags.length) {
          this.queryParams.constraint = currentTags.join('+');
        } else {
          delete this.queryParams.constraint;
        }

        this.filterAjaxRequest();
      });
    },

    // Setup category filter events
    setupCategoryFilters() {
      $('.block-category.ajax a').off('click').on('click', (e) => {
        e.preventDefault();

        const $link = $(e.currentTarget);
        if (!$link.hasClass(CONFIG.classes.active)) {
          delete this.queryParams.q;
          this.filterAjaxRequest($link.attr('href'));
          
          $('.block-category.ajax a.' + CONFIG.classes.active).removeClass(CONFIG.classes.active);
          $link.addClass(CONFIG.classes.active);
        }
      });
    },

    // Setup clear filter buttons
    setupClearButtons() {
      // Clear all filters
      $('.refined-widgets a.clear-all').off('click').on('click', (e) => {
        e.preventDefault();
        delete this.queryParams.constraint;
        delete this.queryParams.q;
        this.filterAjaxRequest();
      });

      // Clear individual filter groups
      $('.filter-tag').each((index, element) => {
        const $filterTag = $(element);
        const $clearBtn = $filterTag.find('.clear');

        if ($filterTag.find('input:checked').length > 0) {
          $clearBtn.show().off('click').on('click', (e) => {
            e.preventDefault();

            let currentTags = this.queryParams.constraint ? this.queryParams.constraint.split('+') : [];

            $filterTag.find('input:checked').each(function() {
              const tagName = $(this).val();
              currentTags = currentTags.filter(tag => tag !== tagName);
            });

            if (currentTags.length) {
              this.queryParams.constraint = currentTags.join('+');
            } else {
              delete this.queryParams.constraint;
            }

            this.filterAjaxRequest();
          });
        }
      });
    },

    // Reset filter UI to match URL state
    resetFilterUI() {
      $('.filter-custom .' + CONFIG.classes.active + ', .filter-links .' + CONFIG.classes.active)
        .removeClass(CONFIG.classes.active);
      $('.filter-tag input:checked').prop('checked', false);

      // Highlight active category
      const categoryMatch = location.pathname.match(/\/collections\/([^?]*)/);
      if (categoryMatch && categoryMatch[0]) {
        $(`.filter-links a[href='${categoryMatch[0]}']`).addClass(CONFIG.classes.active);
      }
    },

    // Initialize collection sorting
    initCollectionSorting() {
      $('.collection-sortBy li a').off('click').on('click', (e) => {
        e.preventDefault();

        const $link = $(e.currentTarget);
        if (!$link.parent().hasClass(CONFIG.classes.active)) {
          this.queryParams.sort_by = $link.attr('href');
          this.filterAjaxRequest();

          $('.collection-sortBy li.' + CONFIG.classes.active).removeClass(CONFIG.classes.active);
          $link.parent().addClass(CONFIG.classes.active);
        }

        // Update dropdown label
        const selectedText = $link.text();
        $link.closest('.dropdown-toggle').find('.dropdown-label').text(selectedText);
        $link.closest('.dropdown-content').removeClass(CONFIG.classes.active);
      });
    },

    // Initialize view mode toggle (grid/list)
    initCollectionViewMode() {
      $('.view-mode a').off('click').on('click', (e) => {
        e.preventDefault();

        const $link = $(e.currentTarget);
        if ($link.hasClass(CONFIG.classes.active)) {
          return false;
        }

        const paging = $('.collection-show .dropdown-label').text();
        this.queryParams.view = $link.hasClass('list') ? `list${paging}` : paging;

        this.filterAjaxRequest();

        $('.view-mode a.' + CONFIG.classes.active).removeClass(CONFIG.classes.active);
        $link.addClass(CONFIG.classes.active);
      });
    },

    // Initialize products per page selector
    initCollectionShow() {
      $('.collection-show li a').off('click').on('click', (e) => {
        e.preventDefault();

        const $link = $(e.currentTarget);
        if ($link.parent().hasClass(CONFIG.classes.active)) {
          return;
        }

        const currentPage = $link.attr('href');
        const viewMode = $('.view-mode a.' + CONFIG.classes.active).attr('data-mode');

        this.queryParams.view = viewMode === 'list' ? `list${currentPage}` : currentPage;
        this.filterAjaxRequest();

        $('.collection-show li.' + CONFIG.classes.active).removeClass(CONFIG.classes.active);
        $link.parent().addClass(CONFIG.classes.active);

        // Update dropdown
        $link.closest('.dropdown-toggle').find('.dropdown-label').text(currentPage);
        $link.closest('.dropdown-content').removeClass(CONFIG.classes.active);
      });
    },

    // Initialize pagination
    initPaging() {
      $(CONFIG.selectors.pagination + ' a').off('click').on('click', (e) => {
        e.preventDefault();

        const href = $(e.currentTarget).attr('href');
        const pageMatch = href.match(/page=(\d+)/);

        if (pageMatch && pageMatch[1]) {
          this.queryParams.page = parseInt(pageMatch[1], 10);

          if (this.queryParams.page) {
            const newUrl = this.buildUrl();
            this.filterClick = true;

            History.pushState({ param: this.queryParams }, newUrl, newUrl);
            this.fetchAndUpdateContent(newUrl);

            // Smooth scroll to top
            $('html, body').animate({ scrollTop: 0 }, 600);
          }
        }
      });
    },

    // Loading state management
    showLoading() {
      if (typeof gred !== 'undefined' && gred.showPopup) {
        gred.showPopup(CONFIG.selectors.loadingPopup);
      }
    },

    hideLoading() {
      if (typeof gred !== 'undefined' && gred.hidePopup) {
        gred.hidePopup(CONFIG.selectors.loadingPopup);
      }
    },

    // Error handling
    handleAjaxError(xhr) {
      this.hideLoading();
      
      try {
        const response = JSON.parse(xhr.responseText);
        $('.ajax-error-message').text(response.description || 'An error occurred');
      } catch (e) {
        $('.ajax-error-message').text('An error occurred while loading content');
      }

      if (typeof gred !== 'undefined' && gred.showPopup) {
        gred.showPopup(CONFIG.selectors.errorPopup);
      }
    }
  };

  // Initialize on document ready
  $(document).ready(() => {
    CollectionManager.init();
  });

  // Expose to global scope if needed for external access
  window.CollectionManager = CollectionManager;

})(jQuery);